module.exports = __webpack_public_path__ + "img/master_sensor_appliance.549f87da.png";